import { LoaderFunctionArgs, redirect } from "react-router";

export default async function entityAdministratorLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/organization/users");
  return routeParams;
}
